import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	ThankWrapper,
	Title,
	Message,
	Check,
} from './thankYouStyles';

class ThankYou extends PureComponent {
	render () {
		const {
			title,
			message,
			noCheck,
		} = this.props;

		return (
			<ThankWrapper>
				{!noCheck && (
					<Check width="40" height="32" />
				)}
				<Title>{ title }</Title>
				<Message>{ message }</Message>
			</ThankWrapper>
		);
	}

	static propTypes = {
		title: PropTypes.string,
		message: PropTypes.string,
		noCheck: PropTypes.bool,
	}
}

export default ThankYou;
